export const formatarDate = (date) => {
  const doisDigitos = (valor) => String(valor).padStart(2, "0");

  const dia = doisDigitos(date.getUTCDate());
  const mes = doisDigitos(date.getUTCMonth() + 1);
  const ano = date.getUTCFullYear();
  const hora = doisDigitos(date.getUTCHours());
  const minuto = doisDigitos(date.getUTCMinutes());
  const segundo = doisDigitos(date.getUTCSeconds());

  // ISO string em UTC
  const dateAndTimeStr = `${ano}-${mes}-${dia}T${hora}:${minuto}:${segundo}Z`;

  return { dia, mes, ano, hora, minuto, segundo, dateAndTimeStr };
};
